import { render, staticRenderFns } from "./ChapterItem.vue?vue&type=template&id=2f5a01b5&scoped=true&"
import script from "./ChapterItem.vue?vue&type=script&lang=ts&"
export * from "./ChapterItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterItem.vue?vue&type=style&index=0&id=2f5a01b5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a01b5",
  null
  
)

export default component.exports